import { decamelizeKeys } from 'humps'

import type { ListUnassignedBookingsParams } from './type'

export const getUnassignedBookingsEndpoint = (params: ListUnassignedBookingsParams): string => {
  const snakeParams = decamelizeKeys(params) as Record<string, string | number | undefined>
  const query = new URLSearchParams()
  for (const [key, value] of Object.entries(snakeParams)) {
    if (value !== undefined && value !== null) {
      query.append(key, String(value))
    }
  }
  return `/berths/bookings/unassign?${query.toString()}`
}
